// extracted by css-extract-rspack-plugin
export default {"banner-container":"PHZTzwl___banner-container","bannerContainer":"PHZTzwl___banner-container"};